// Import necessary modules
import axios from 'axios';

// Determine the base URL from environment variable or sensible defaults
// In local development (localhost), talk to the local Django API by default.
// In other environments, fall back to the hosted backend.
const baseURL =
  process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:8000/api/'
    : 'https://serenimindbackend.onrender.com/api/');

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 1000000, // Adjust timeout as needed
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve the token from localStorage or context
    const token = localStorage.getItem('token'); // Example: localStorage
    if (token) {
      console.log('Token found:', token); // Debug log
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.log('No token found'); // Debug log
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error); // Debug log
    return Promise.reject(error);
  }
);

export default axiosInstance;
